'use client';

import { useEffect } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { SessionProvider } from 'next-auth/react';

export default function Providers({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  //   useEffect(() => {
  //     const access = searchParams.get('access');

  //     // If access=private exists, append to future navigations
  //     if (access === 'private') {
  //       const query = new URLSearchParams(searchParams);
  //       if (!query.has('access')) {
  //         query.set('access', 'private');
  //         router.replace(`${pathname}?${query.toString()}`);
  //       }
  //     } else {
  //       router.push('/coming-soon');
  //     }
  //   }, []);

  return <SessionProvider>{children}</SessionProvider>;
}
